<!-- <div class="top" [ngStyle]="styles">
    <div class="date">
    <input *ngIf="!textToggle || isDate" [(ngModel)]="dateModel" [title]="(dateValue | date : 'yyyy-MM-dd') || ''" class="date" [placeholder]="title || 'yyyy-mm-dd'"
        ngbDatepicker [disabled]="disabled" [footerTemplate]="today" #d="ngbDatepicker" (click)="d.toggle()" (dateSelect)="updateDate($event)">
    <input *ngIf="textToggle && !isDate"  [title]="textValue" class="date" class="text" [(ngModel)]="textValue" [placeholder]="title || 'Text'" 
        (input)="updateText($any($event.target).value)" [attr.disabled]="disabled ? '' : null">
    </div>
    <div *ngIf="isDate && !disabled" class="button">
      <button (click)="clear()" title="clear date">X</button>
    </div>
    <div *ngIf="textToggle && !disabled" class="button">
        <button *ngIf="isDate" (click)="toggle()" class="togglesymbol" title="switch to text">T</button>
        <button *ngIf="!isDate" (click)="toggle()" class="togglesymbol" title="switch to date" style="padding-left:2px">D</button>
    </div>
</div>

<ng-template #today>
    <div style="text-align:center;margin-bottom:5px;"><button class="nrk-button" (click)="emitDate()">Today</button></div>
</ng-template> -->

<div class="top" [ngStyle]="styles">
    <div class="date">
        <input [(ngModel)]="dateModel" [name]="uid" class="date" [placeholder]="title || 'yyyy-mm-dd'"
            ngbDatepicker #dp="ngbDatepicker" [disabled]="disabled" [footerTemplate]="today"
            (dateSelect)="updateDate($event)" [ngModelOptions]="{ updateOn: 'blur' }" 
            (ngModelChange)="onDateModelChange($event)"
            (closed)="showRemark = true"
        >
    </div>
    <div *ngIf="isDate && !disabled" class="button" style="white-space:nowrap">
      <button (click)="dp.toggle()" style="margin:0;padding:0;width:22px" title="Open Calendar">📅</button>
      <!-- <button (click)="clear()" style="margin:0;padding:0;width:16px" title="clear date">X</button> -->
    </div>
</div>

<ng-template #today>
    <div style="text-align:center;margin-bottom:5px;">
        <button class="nrk-button" (click)="emitDate()">Today</button>
    </div>
    <div *ngIf="erpDate && showRemark" style="position:absolute;top:0;text-align:center;background-color:#dddd;height:100%;z-index:10;padding:4rem 0.5rem 0.5rem 0.5rem">
        Remark:
        <!-- <ngx-doc-form-texfield [(value)]="erpDate.remark"></ngx-doc-form-texfield>  -->
        <!-- <ngx-form-text [multiline]="5" [(value)]="erpDate.remark"></ngx-form-text> -->
        <ngx-doc-form-texfield [(value)]="erpDate.remark"></ngx-doc-form-texfield> 
        <div><button class="nrk-button mt-4" (click)="showRemark=false">Next ▸</button></div>
        
    </div>
</ng-template>
